import colors from './colors';
import customTheme from './customTheme';

const theme = {
    colors,
    customTheme,
    overMobile: '1024px',
    mobile: '(max-width: 1024px)',
    desktop: '(min-width: 1025px)',
    tablet: '(min-width: 1025px) and (max-width: 1440px)',
    desktop2: '(min-width: 1441px)',
    shadow: '1px 2px 4px rgba(52, 52, 52, 0.25)',
    authHeaderShadow: '1px -2px 4px rgba(52, 52, 52, 0.25)',
    navShadow: '0 1px 2px rgba(52, 52, 52, 0.25)',
    buttonShadow: '0 4px 4px rgba(52, 52, 52, 0.25)',
    shadowLeft: '-4px 4px 4px rgba(52, 52, 52, 0.25)',
    shadowRight: '2px 2px 4px rgba(52, 52, 52, 0.25)',
};


export default theme;